// 物件検索
import search from '@/constants/search'
const searchList = search
const SearchProperty = {
  namespaced: true,

  state: {
    search: search,
    status: {
      total: 0,
      per_page: 20,
      current_page: 1,
      from: 1,
      to: 20,
    },
  },
  getters: {
    getSearch: state => {
      return state.search
    },
    getStatus: state => {
      return state.status
    },
  },
  mutations: {
    setSearch(state, search) {
      state.search = search
    },
    setStatus(state, status) {
      state.status = { ...state.status, ...status }
    },
  },
  actions: {
    reset({ commit }) {
      const status = {
        total: 0,
        per_page: 20,
        current_page: 1,
        from: 1,
        to: 20,
      }
      const search = _.cloneDeep(searchList)
      commit('setStatus', status)
      commit('setSearch', search)
    },
  },
}

export default SearchProperty
